/**
 * The game's design resolution: 1080×1920, fit-height (the canvas the art was drawn for).
 * Every prefab number the port carries over is a DESIGN UNIT in this space.
 */
export const DESIGN_RESOLUTION = { width: 1080, height: 1920 } as const;

/** The viewport in design units plus the CSS pixels per design unit. */
export interface DesignViewport {
  width: number;
  height: number;
  scale: number;
}

/**
 * Fit-height: the design height always spans the viewport height, the design width follows
 * the aspect ratio (3413 on 16:9, 1080 on 9:16). This is what `view.getVisibleSize()` returned.
 */
export function resolveDesignViewport(css: { width: number; height: number }): DesignViewport {
  const scale = Math.max(1, css.height) / DESIGN_RESOLUTION.height;
  return { width: css.width / scale, height: DESIGN_RESOLUTION.height, scale };
}
